import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import NProgress from 'nprogress';
import api from '@/api';
import VLayout from '@/components/layout/VLayout.vue';
import VSupplierLayout from '@/components/layout/VSupplierLayout.vue';
import TheLogin from '@/views/auth/TheLogin.vue';
import TheAdminPaxs from '@/views/admin/pax/TheAdminPaxs.vue';
import TheAdminUsers from '@/views/admin/user/TheAdminUsers.vue';
import TheAdminAgencies from '@/views/admin/agency/TheAdminAgencies.vue';
import TheAdminCollaborators from '@/views/admin/collaborator/TheAdminCollaborator.vue';
import TheClients from '@/views/client/TheClients.vue';
import TheResources from '@/views/resource/TheResources.vue';
import TheSuppliers from '@/views/supplier/TheSuppliers.vue';
import TheCases from '@/views/case/TheCases.vue';
import TheCase from '@/views/case/TheCase.vue';
import TheCaseSetup from '@/views/case/parts/TheCaseSetup.vue';
import TheTourBuilder from '@/views/case/parts/TheTourBuilder.vue';
import TheTourReservations from '@/views/case/parts/TheTourReservations.vue';
import TheTourPricing from '@/views/case/parts/TheTourPricing.vue';
import TheTemplates from '@/views/template/TheTemplates.vue';
import TheTourTravelersForm from '@/views/TheTourTravelersForm.vue';
import TheCaseTravelersDetailsForm from '@/views/TheCaseTravelersDetailsForm.vue';
import TheTemplate from '@/views/template/TheTemplate.vue';
import TheTemplateSetup from '@/views/template/parts/TheTemplateSetup.vue';
import TheTemplateBuilder from '@/views/template/parts/TheTemplateBuilder.vue';
import { useAppStore } from '@/stores/app';
import { useAuthStore } from '@/stores/auth';
import ThePreviewPdf from '@/views/travel-book/ThePreviewPdf.vue';
import TheQuotePdf from '@/views/travel-book/TheQuotePdf.vue';
import TheReservationConfirm from '@/views/TheReservationConfirm.vue';
import TheDashboard from '@/views/TheDashboard.vue';
import TheEmailTemplate from "@/views/TheEmailTemplate.vue";
import TheEmailConfirmationVue from '@/views/TheEmailConfirmation.vue';
import TheInvoicePdf from '@/views/travel-book/TheInvoicePdf.vue';
import TheCaseInvoicePdf from '@/views/travel-book/TheCaseInvoicePdf.vue';
import TheTemplateV2 from '@/views/template/V2/TheTemplateV2.vue';
import TheTemplatesV2 from '@/views/template/V2/TheTemplatesV2.vue';
import TheTemplateSetupV2 from '@/views/template/parts/V2/TheTemplateSetupV2.vue';
import TheTemplateBuilderV2 from '@/views/template/parts/V2/TheTemplateBuilderV2.vue';
import TheTemplatePricingMatrixV2 from '@/views/template/parts/V2/TheTemplatePricingMatrixV2.vue';
import TheActivityPreviewV2 from '@/views/template/parts/V2/TheActivityPreviewV2.vue';
import TheCaseV2 from '@/views/case/V2/TheCaseV2.vue';
import TheCasesV2 from '@/views/case/V2/TheCasesV2.vue';
import TheCaseSetupV2 from '@/views/case/parts/V2/TheCaseSetupV2.vue';
import ThePreviewPdfV2 from '@/views/travel-book/V2/ThePreviewPdfV2.vue';
import TheQuotePdfv2 from '@/views/travel-book/V2/TheQuotePdfv2.vue';
import TheCaseBuilder from '@/views/case/parts/V2/TheCaseBuilder.vue';
import TheCasePricing from '@/views/case/parts/V2/TheCasePricing.vue';
import TheCasePreviewV2 from '@/views/case/V2/TheCasePreviewV2.vue';
import TheCms from '@/views/cms/TheCms.vue';
import TheCmsDashboard from '@/views/cms/TheCmsDashboard.vue';
import TheCmsActivities from '@/views/cms/TheCmsActivities.vue';
import TheCmsStories from '@/views/cms/TheCmsStories.vue';
import TheCmsGuides from '@/views/cms/TheCmsGuides.vue';
import TheCmsReviews from '@/views/cms/TheCmsReviews.vue';
import TheCmsHelpCenter from '@/views/cms/TheCmsHelpCenter.vue';
import TheCmsHelpCenterArticleForm from '@/views/cms/TheCmsHelpCenterArticleForm.vue';
import TheCmsFaqCategoryForm from '@/views/cms/TheCmsFaqCategoryForm.vue';
import TheCmsFaqForm from '@/views/cms/TheCmsFaqForm.vue';
import TheCmsFaqManagement from '@/views/cms/TheCmsFaqManagement.vue';
import TheCmsSettings from '@/views/cms/TheCmsSettings.vue';
import TheCmsActivityForm from '@/views/cms/TheCmsActivityForm.vue';
import TheCmsStoryForm from '@/views/cms/TheCmsStoryForm.vue';
import TheCmsGuideForm from '@/views/cms/TheCmsGuideForm.vue';
import TheCmsTeamMembers from '@/views/cms/TheCmsTeamMembers.vue';
import TheCmsTeamMemberForm from '@/views/cms/TheCmsTeamMemberForm.vue';
import TheCmsReviewForm from '@/views/cms/TheCmsReviewForm.vue';
import TheCmsContactMessages from '@/views/cms/TheCmsContactMessages.vue';
import TheCmsPages from '@/views/cms/TheCmsPages.vue';
import TheCmsPageForm from '@/views/cms/TheCmsPageForm.vue';
import TheCmsMenus from '@/views/cms/TheCmsMenus.vue';
import TheCmsMenuForm from '@/views/cms/TheCmsMenuForm.vue';
import TheCmsMedia from '@/views/cms/TheCmsMedia.vue';
import CmsLayout from '@/components/cms/CmsLayout.vue';
import TheEmailAcceptTemplate from '@/views/TheEmailAcceptTemplate.vue';
import TheQuoteConfirm from '@/views/TheQuoteConfirm.vue';
import TheEmailDeclineTemplate from '@/views/TheEmailDeclineTemplate.vue';
import TheEmailModificationTemplate from '@/views/TheEmailModificationTemplate.vue';
import TheCaseQuote from '@/views/case/parts/V2/TheCaseQuote.vue';

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: '/login',
    name: 'login',
    component: TheLogin,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/auth/social/:provider/confirm',
    name: 'auth.social.confirm',
    redirect: (to) => {
      return { name: 'login', query: to.query };
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/cases/:caseId/tour/:tourId/invoice/:invoice/preview',
    name: 'tour.invoice.invoice',
    component: TheInvoicePdf,
    props: true,
    meta: {
      isPublic: true,
    }
  },
  {
    path: '/cases/:caseId/invoice/:invoice/preview',
    name: 'case.invoice.invoice',
    component: TheCaseInvoicePdf,
    props: true,
    meta: {
      isPublic: true,
    }
  },
  {
    path: '/cases/:caseId/tour/:tourId/preview',
    name: 'tour.travel-book.preview',
    component: ThePreviewPdf,
    props: true,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/cases-v2/:caseId/tour-v2/:tourId/preview',
    name: 'case.travel-book.preview',
    component: ThePreviewPdfV2,
    props: true,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/v2/public/case/:caseId/preview',
    name: 'case.preview.public',
    component: TheCasePreviewV2,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/cases/:caseId/tour/:tourId/quote',
    name: 'tour.travel-book.quote',
    component: TheQuotePdf,
    props: true,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/cases-v2/:caseId/tour-v2/:tourId/quote',
    name: 'case.travel-book.quote',
    component: TheQuotePdfv2,
    props: true,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/reservation-confirm',
    name: 'reservation.confirm',
    component: TheReservationConfirm,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/travelers-form',
    name: 'travelers.form',
    component: TheTourTravelersForm,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/travelers-details-form',
    name: 'travelers.details.form',
    component: TheCaseTravelersDetailsForm,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/email-confirm',
    name: 'email.confirm',
    component: TheEmailTemplate,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/thankyou',
    name: 'thankyou',
    component: TheEmailConfirmationVue,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/accept',
    name: 'email.accept',
    component: TheEmailAcceptTemplate,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/quote-confirm',
    name: 'quote.confirm',
    component: TheQuoteConfirm,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/decline',
    name: 'email.decline',
    component: TheEmailDeclineTemplate,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/modify',
    name: 'email.modification',
    component: TheEmailModificationTemplate,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/supplier-portal',
    component: VSupplierLayout,
    children: [
      {
        path: '',
        redirect: { name: 'supplierPortal.upcoming' },
      },
      {
        path: 'upcoming',
        name: 'supplierPortal.upcoming',
        component: () => import('@/views/supplier/TheSupplierPortal.vue'),
        props: { type: 'upcoming' },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'past',
        name: 'supplierPortal.past',
        component: () => import('@/views/supplier/TheSupplierPortal.vue'),
        props: { type: 'past' },
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/',
    name: 'home',
    component: VLayout,
    children: [
      {
        path: 'admin',
        name: 'admin',
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'paxs',
            name: 'pax.index',
            component: TheAdminPaxs,
            meta: {
              requiresAuth: true,
              permission: 'agency.index',
            },
          },
          {
            path: 'users',
            name: 'user.index',
            component: TheAdminUsers,
            meta: {
              requiresAuth: true,
              permission: 'user.index',
            },
          },
          {
            path: 'agencies',
            name: 'agency.index',
            component: TheAdminAgencies,
            meta: {
              requiresAuth: true,
              permission: 'agency.index',
            },
          },
          {
            path: 'collaborators',
            name: 'collaborators',
            component: TheAdminCollaborators,
            meta: {
              requiresAuth: false,
              permission: 'agency.index',
            },
          },
        ],
      },
      {
        path: 'cases',
        name: 'case.index',
        component: TheCases,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'cases-v2',
        name: 'case-v2.index',
        component: TheCasesV2,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'resources',
        name: 'resource.index',
        component: TheResources,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'clients',
        name: 'client.index',
        component: TheClients,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'suppliers',
        name: 'supplier.index',
        component: TheSuppliers,
        meta: {
          requiresAuth: true,
        },
      },
      //modified by alvaro !
      {
        path: 'cms',
        name: 'cms',
        component: TheCms,
        redirect: { name: 'cms.dashboard' },
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'dashboard',
            name: 'cms.dashboard',
            component: TheCmsDashboard,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'activities',
            name: 'cms.activities',
            component: TheCmsActivities,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'activities/create',
            name: 'cms.activities.create',
            component: TheCmsActivityForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'activities/:id/edit',
            name: 'cms.activities.edit',
            component: TheCmsActivityForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'stories',
            name: 'cms.stories',
            component: TheCmsStories,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'stories/create',
            name: 'cms.stories.create',
            component: TheCmsStoryForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'stories/:id/edit',
            name: 'cms.stories.edit',
            component: TheCmsStoryForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'guiders',
            name: 'cms.guiders',
            component: TheCmsGuides,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'guiders/create',
            name: 'cms.guiders.create',
            component: TheCmsGuideForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'guiders/:id/edit',
            name: 'cms.guiders.edit',
            component: TheCmsGuideForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'team-members',
            name: 'cms.team-members',
            component: TheCmsTeamMembers,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'team-members/create',
            name: 'cms.team-members.create',
            component: TheCmsTeamMemberForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'team-members/:id/edit',
            name: 'cms.team-members.edit',
            component: TheCmsTeamMemberForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'reviews',
            name: 'cms.reviews',
            component: TheCmsReviews,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'reviews/create',
            name: 'cms.reviews.create',
            component: TheCmsReviewForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'reviews/:id/edit',
            name: 'cms.reviews.edit',
            component: TheCmsReviewForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'contact-messages',
            name: 'cms.contact-messages',
            component: TheCmsContactMessages,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'help-center',
            name: 'cms.help-center',
            component: TheCmsHelpCenter,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'help-center/categories/create',
            name: 'cms.help-center.create-category',
            component: TheCmsFaqCategoryForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'help-center/categories/:id/edit',
            name: 'cms.help-center.edit-category',
            component: TheCmsFaqCategoryForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'help-center/categories/:categoryId/faqs',
            name: 'cms.help-center.faqs',
            component: TheCmsFaqManagement,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'help-center/faqs/create',
            name: 'cms.help-center.create-faq',
            component: TheCmsFaqForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'help-center/faqs/:id/edit',
            name: 'cms.help-center.edit-faq',
            component: TheCmsFaqForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'pages',
            name: 'cms.pages',
            component: TheCmsPages,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'pages/create',
            name: 'cms.pages.create',
            component: TheCmsPageForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'pages/:id/edit',
            name: 'cms.pages.edit',
            component: TheCmsPageForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'menus',
            name: 'cms.menus',
            component: TheCmsMenus,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'menus/create',
            name: 'cms.menus.create',
            component: TheCmsMenuForm,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'menus/:id/edit',
            name: 'cms.menus.edit',
            component: TheCmsMenuForm,
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'settings',
            name: 'cms.settings',
            component: TheCmsSettings,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'media',
            name: 'cms.media',
            component: TheCmsMedia,
            meta: {
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'cases',
        name: 'cases',
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: ':caseId',
            name: 'case.show',
            component: TheCase,
            props: true,
            meta: {
              requiresAuth: true,
            },
            children: [
              {
                path: 'tour/:tourId',
                redirect: 'tour.default',
                name: 'tour.index',
                props: true,
                meta: {
                  requiresAuth: true,
                },
                children: [
                  {
                    path: '',
                    name: 'tour.default',
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                    beforeEnter: (to, from, next) => {
                      next({
                        name: 'case.show',
                        params: {
                          caseId: to.params.caseId,
                          tourId: to.params.tourId,
                        },
                      });
                    },
                  },
                  {
                    path: 'setup',
                    name: 'case.setup.show',
                    component: TheCaseSetup,
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                  },
                  {
                    path: 'builder',
                    name: 'tour.builder.show',
                    component: TheTourBuilder,
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                  },
                  {
                    path: 'statuses',
                    name: 'tour.bookings.show',
                    component: TheTourReservations,
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                  },
                  {
                    path: 'pricing',
                    name: 'tour.pricing.show',
                    component: TheTourPricing,
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "cases-v2",
        name: "cases-v2",
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: ':caseId',
            name: 'case-v2.show',
            component: TheCaseV2,
            props: true,
            meta: {
              requiresAuth: true,
            },
            children: [
              {
                path: '',
                redirect: 'tour-v2.default',
                name: 'tour-v2.index',
                props: true,
                meta: {
                  requiresAuth: true,
                },
                children: [
                  {
                    path: '',
                    name: 'tour-v2.default',
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                    beforeEnter: (to, from, next) => {
                      next({
                        name: 'case-v2.show',
                        params: {
                          caseId: to.params.caseId,
                        },
                      });
                    },
                  },
                  {
                    path: 'setup',
                    name: 'case-v2.setup.show',
                    component: TheCaseSetupV2,
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                  },
                  {
                    path: 'builder',
                    name: 'case.builder.show',
                    component: TheCaseBuilder,
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                  },
                  {
                    path: 'pricing',
                    name: 'case.pricing.show',
                    component: TheCasePricing,
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                  },
                  {
                    path: 'billing-invoice',
                    name: 'case.billing-invoice.show',
                    component: TheCaseQuote,
                    props: true,
                    meta: {
                      requiresAuth: true,
                    },
                  },
                ],
              },
            ],
          }
        ]
      },
      {
        path: 'activities',
        name: 'templates',
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            name: 'template.index',
            component: TheTemplates,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: ':templateId',
            name: 'template.show',
            component: TheTemplate,
            props: true,
            meta: {
              requiresAuth: true,
            },
            children: [
              {
                path: 'setup',
                name: 'template.setup.show',
                component: TheTemplateSetup,
                props: true,
                meta: {
                  requiresAuth: true,
                },
              },
              {
                path: 'builder',
                name: 'template.builder.show',
                component: TheTemplateBuilder,
                props: true,
                meta: {
                  requiresAuth: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'activities-v2',
        name: 'activities',
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            name: 'activities.index',
            component: TheTemplatesV2,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: ':activitiesId',
            name: 'activities.show',
            component: TheTemplateV2,
            props: true,
            meta: {
              requiresAuth: true,
            },
            children: [
              {
                path: 'setup',
                name: 'activities.setup.show',
                component: TheTemplateSetupV2,
                props: true,
                meta: {
                  requiresAuth: true,
                },
              },
              {
                path: 'builder',
                name: 'activities.builder.show',
                component: TheTemplateBuilderV2,
                props: true,
                meta: {
                  requiresAuth: true,
                },
              },
              {
                path: 'pricing-matrix',
                name: 'activities.pricing-matrix.show',
                component: TheTemplatePricingMatrixV2,
                props: true,
                meta: {
                  requiresAuth: true,
                },
              },
              {
                path: 'preview',
                name: 'activities.preview.show',
                component: TheActivityPreviewV2,
                props: true,
                meta: {
                  requiresAuth: true,
                },
              },
            ],
          },
        ],
      },
      {
        path:'/dashboard',
        name: 'collaboratorDashboard',
        component: TheDashboard,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const history = createWebHistory();

const router = createRouter({
  history,
  routes,
});

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  if (to.name === 'home') {
    return next({ name: 'case-v2.index' });
  }

  const isPublic = to.matched.some((record) => record.meta.isPublic);

  // When the user is guest
  if (isPublic) {
    return next();
  }

  let isLogged;

  try {
    isLogged = await api.auth.check();
  } catch (error) {
    isLogged = false;
  }

  const reqAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (!reqAuth && isLogged) {
    return next({ name: 'home' });
  } else if (reqAuth && !isLogged) {
    return next({
      name: 'login',
      query: { redirect: to.fullPath },
    });
  }

  const { redirect } = to.query;

  // Redirect after login
  if (!!redirect && isLogged) {
    return next({ path: redirect });
  }

  const authStore = useAuthStore();
  const isSupplier = localStorage.getItem('isSupplier') === 'true';

  // Role based redirection
  if (isLogged) {
    const isSupplierPortal = to.matched.some((record) => record.name && String(record.name).startsWith('supplierPortal'));
    const isCollaboratorDashboard = to.name === 'collaboratorDashboard';

    // Supplier access control
    if (isSupplier) {
      if (!isSupplierPortal && to.meta.requiresAuth && !to.meta.isPublic) {
        return next({ name: 'supplierPortal.upcoming' });
      }
    } else {
      // Non-supplier trying to access supplier portal
      const isAdmin = authStore.user?.roles?.some((r: any) => r.name === 'admin');
      if (isSupplierPortal && !isAdmin) {
        return next({ name: 'case-v2.index' });
      }
    }

    // Collaborator or Admin/SuperAdmin dashboard access control
    if (isCollaboratorDashboard) {
      const isAdminOrSuperAdmin = authStore.user?.roles?.some((r: any) => r.name === 'admin' || r.name === 'super_admin');
      const isCollaborator = !!authStore.agency?.isCollaborator;
      if (!isCollaborator && !isAdminOrSuperAdmin) {
        return next({ name: 'case-v2.index' });
      }
    }
  }

  // TODO apply permissions for route
  const appStore = useAppStore();

  // If we don't have permissions in store, get them
  if (isLogged && appStore.permissions.length === 0) {
    await authStore.getPermissions();
  }

  const { permission } = to.meta;

  // If the route doesn't have a permission, continue
  if (!permission) {
    return next();
  }

  const canPass = appStore.permissions.includes(permission);

  if (!canPass) {
    return next({ name: 'case-v2.index' });
  }

  return next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
